import { Customer } from '../../models/customer.model'

export enum CustomerActionType {
    INIT_CUSTOMER = "(INITIAL) SET_CUSTOMER ",
    SET_CUSTOMER = '(SETTER) SET_CUSTOMER',
    SET_FIRSTNAME = '(SETTER) SET_FIRSTNAME',
    SET_LASTNAME = '(SETTER) SET_LASTNAME',
}

export class CustomerState {
    private payload: Customer;

    constructor(payload: Customer) {
        this.payload = payload
    }

    setFirstname(firstname: string) {
        this.payload.firstname = firstname
    }

    setLastname(lastname: string) {
        this.payload.lastname = lastname;
    }

    getValue(): Customer {
        return this.payload;
    }
}

export class InitialCustomerAction{
    readonly type:string = CustomerActionType.INIT_CUSTOMER;
    payload:Customer;
    constructor(){
        this.payload = null;
    }
}

export class SetCustomerAction{
    readonly type:string = CustomerActionType.SET_CUSTOMER
    payload: Customer;

    constructor(payload:Customer){
        this.payload = payload;
    }
}

export class SetCustomerFirstnameAction{
    readonly type:string = CustomerActionType.SET_FIRSTNAME;
    payload:  Customer;

    constructor(payload: Customer){
        this.payload = payload
    }
}


export class SetCustomerLastnameAction{
    readonly type: string = CustomerActionType.SET_LASTNAME;
    payload: Customer;
    
    constructor(payload: Customer){
        this.payload = payload;
    }
}


export type CustomerAction = InitialCustomerAction | SetCustomerAction | SetCustomerFirstnameAction | SetCustomerLastnameAction;
